// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1m2Bt","content":"styles_content__IRPVy","selectAll":"styles_selectAll__1IUTN"};